module.exports = __webpack_public_path__ + "static/img/yellow-ballon-thumb.cb35336.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/yellow-ballon-thumb.jpg
// module id = pPxY
// module chunks = 0